import { CheckCheck, Trash2 } from "lucide-react";
import { type FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { NotificationFilter } from "@recobra/schemas/notification";
import { Badge } from "@recobra/ui/badge";
import { Button } from "@recobra/ui/button";

export const NotificationInboxHeader: FC<{
  unreadCount: number;
  readCount: number;
  onMarkAllRead: () => void;
  onClearRead: () => void;
  markAllPending: boolean;
  clearPending: boolean;
}> = ({ unreadCount, readCount, onMarkAllRead, onClearRead, markAllPending, clearPending }) => (
  <div className="flex items-center justify-between gap-2 border-b px-3 py-2.5">
    <div className="flex items-center gap-1.5">
      <h2 className="font-semibold text-sm">{m.notifications_title()}</h2>
      {unreadCount > 0 ? <Badge variant="secondary">{unreadCount}</Badge> : null}
    </div>
    <div className="flex shrink-0 items-center">
      <Button
        variant="ghost"
        size="xs"
        onClick={onMarkAllRead}
        disabled={markAllPending || unreadCount === 0}
      >
        <CheckCheck data-icon="inline-start" />
        {m.notifications_mark_all_read()}
      </Button>
      <Button
        variant="ghost"
        size="xs"
        onClick={onClearRead}
        disabled={clearPending || readCount === 0}
      >
        <Trash2 data-icon="inline-start" />
        {m.notifications_clear_read()}
      </Button>
    </div>
  </div>
);

export const notificationTabCount = (
  value: NotificationFilter,
  summary?: { unread: number; byCategory?: { mention: number; system: number } },
) => {
  if (!summary) return undefined;
  if (value === "all") return summary.unread > 0 ? summary.unread : undefined;
  if (value === "mention") return summary.byCategory?.mention || undefined;
  if (value === "system") return summary.byCategory?.system || undefined;

  return undefined;
};

export const notificationTabLabel = (value: NotificationFilter) => {
  if (value === "all") return m.notifications_tab_all();
  if (value === "unread") return m.notifications_tab_unread();
  if (value === "mention") return m.notifications_tab_mentions();

  return m.notifications_tab_system();
};
